import React from 'react';

export const SbRespTradeSourcingBannerLazy = React.lazy(() =>
    import(/* webpackChunkName: "SbRespTradeSourcingBanner" */ './SbRespTradeSourcingBannerContent')
);
